module.exports = __webpack_public_path__ + "img/fr.6e0aaecc.svg";